
import { useEffect, useState, useRef } from "react";
import { animate } from "framer-motion";
import { useInView } from "framer-motion";

const CounterOnView = ({ to, duration = 3 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!isInView) return;

    const controls = animate(0, to, {
      duration,
      onUpdate: (v) => setValue(Math.round(v)),
    });

    return () => controls.stop();
  }, [isInView, to, duration]);

  return (
    <span ref={ref}>{value}</span>
  );
};

export default CounterOnView;
